.c8{display:inline-flex;}